// export const baseUrl="https://kt-ap.herokuapp.com"
// export const baseUrl="https://server.spacetrek.com"
// export const baseUrl="http://143.110.242.130:2000"
// export const baseUrl="http://localhost:2000"
// export const baseUrl="http://192.168.1.41:2000"
import {commonBaseUrl} from '../../BaseUrl'
export const baseUrl=`${commonBaseUrl}`